<template>
  <NiceModal :name="name" :title="$gettext('Bulk send invite links')" @close="cancel">
    <section>
      <p class="p-0 mt-0" v-translate>
        The invitation for guest entry will be sent to all partners who have not yet received it, based on the currently active list filters.
      </p>

      <!-- Ignore is sent flag -->
      <NiceSwitch :title="$gettext('Resend email even if it was already sent')" noMargin v-model="form.ignore_is_sent_flag"></NiceSwitch>

      <NiceLoading v-if="loading" fullDiv></NiceLoading>

      <!-- <pre>{{ form }}</pre> -->
    </section>

    <template #footer>
      <!-- Cancel -->
      <NiceButton :text="$gettext('Cancel')" @click="cancel" type="default" plain icon="icon-x" />

      <!-- Send -->
      <NiceButton :text="$gettext('Send')" @click="submit" icon="icon-check" />
    </template>
  </NiceModal>
</template>

<script setup>
import ApiService from "@/services/api/api.service";
import CommonService from "@/services/common.service";
import ErrorService from "@/services/error.service";

import { defineEmits, inject, ref, onMounted } from "vue";
const nice = inject("nice");
const $getQuery = inject("getQuery");

import { useRouter } from "vue-router";
const router = useRouter();

import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();

const emit = defineEmits(["cancel", "success"]);

const name = "bulk-send-invite-links";
const loading = ref(false);
const form = ref({
  ignore_is_sent_flag: false,
});
const organizationId = router.currentRoute.value.params.organizationId;
const eventId = router.currentRoute.value.params.eventId;

function cancel() {
  nice.modal(name, false);
  emit("cancel");
}

async function submit() {
  loading.value = true;
  try {
    const query = await $getQuery();
    const params = {
      search: query.search,
      is_invite_link_email_sent: query.is_invite_link_email_sent,
      guest_limit_reached: query.guest_limit_reached,
    };
    const response = await ApiService.partners.sendBulkInviteLinks(organizationId, eventId, form.value, params);
    CommonService.success($gettext("Successfully sent %{number} email with invite links.", { number: response.email_count }));
    emit("success");
  } catch (e) {
    ErrorService.showError(e);
  } finally {
    loading.value = false;
  }
}
</script>
